import { Caption, COLORS, Panel, Badge } from "./ui";

// Bounding boxes in image-UV space (x,y = top-left fraction, w,h = size fraction).
const BOXES = [
  {
    label: "cat",
    conf: 0.97,
    x: 0.12,
    y: 0.08,
    w: 0.76,
    h: 0.82,
    color: "#6366f1",
  },
  {
    label: "eye",
    conf: 0.91,
    x: 0.22,
    y: 0.2,
    w: 0.2,
    h: 0.14,
    color: "#a855f7",
  },
  {
    label: "eye",
    conf: 0.89,
    x: 0.4,
    y: 0.2,
    w: 0.2,
    h: 0.14,
    color: "#a855f7",
  },
  {
    label: "nose",
    conf: 0.94,
    x: 0.32,
    y: 0.35,
    w: 0.18,
    h: 0.12,
    color: "#ec4899",
  },
];

export function Detection2D() {
  return (
    <div
      style={{
        position: "absolute",
        inset: 0,
        display: "flex",
        flexDirection: "column",
        overflowY: "auto",
        alignItems: "center",
        justifyContent: "center",
        gap: 16,
        padding: "90px 24px 110px",
        fontFamily: "'General Sans', system-ui, sans-serif",
        textAlign: "center",
        color: COLORS.text,
      }}
    >
      <Badge>Object Detection</Badge>

      {/* Open-vocab prompt — the 2026 twist */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 8,
          fontFamily: "'JetBrains Mono', ui-monospace, monospace",
          fontSize: 13.5,
        }}
      >
        <span style={{ color: COLORS.textDim }}>find:</span>
        {["cat", "eye", "nose", "whiskers"].map((w) => (
          <span
            key={w}
            style={{
              padding: "3px 9px",
              borderRadius: 6,
              background: `${COLORS.indigo}22`,
              border: `1px solid ${COLORS.indigo}55`,
              color: COLORS.indigoLight,
            }}
          >
            {w}
          </span>
        ))}
      </div>

      <div
        style={{
          position: "relative",
          width: "min(360px, 86vw)",
          aspectRatio: "360 / 300",
          borderRadius: 12,
          overflow: "hidden",
          boxShadow: `0 0 40px ${COLORS.indigo}22`,
        }}
      >
        <img
          src="/cv/ref-cat.png"
          alt="cat"
          style={{ width: "100%", height: "100%", objectFit: "cover" }}
        />
        <div
          style={{
            position: "absolute",
            inset: 0,
            background: "rgba(0,0,0,0.12)",
          }}
        />
        {BOXES.map((b, i) => (
          <div
            key={i}
            style={{
              position: "absolute",
              left: `${b.x * 100}%`,
              top: `${b.y * 100}%`,
              width: `${b.w * 100}%`,
              height: `${b.h * 100}%`,
              border: `2px solid ${b.color}`,
              borderRadius: 4,
              boxShadow: `0 0 10px ${b.color}88`,
            }}
          >
            <span
              style={{
                position: "absolute",
                top: -19,
                left: -2,
                fontSize: 12,
                fontWeight: 700,
                fontFamily: "'JetBrains Mono', ui-monospace, monospace",
                color: "#fff",
                background: b.color,
                padding: "1px 6px",
                borderRadius: 4,
                whiteSpace: "nowrap",
              }}
            >
              {b.label} {Math.round(b.conf * 100)}%
            </span>
          </div>
        ))}
      </div>

      <Caption>
        Detection finds <em>where</em> objects are — boxes + class + confidence,
        in a single forward pass (YOLO-style). In 2026,{" "}
        <strong>open-vocabulary</strong> detectors like YOLO-World and Grounding
        DINO go further: give them any text prompt and they’ll locate it, no
        fixed class list required.
      </Caption>
    </div>
  );
}
